import { Metadata } from '@workspaces/types'
import { METADATA } from './flavours/meta'

export const getAppMetadata = (): Metadata.AppMetadata => METADATA

export const getAppFlavour = (): string => getAppMetadata().flavour

export const getAppMetadataLanguages = (): Metadata.Languages =>
  getAppMetadata().languages

export const getAppMetadataLocalStorageKeys = (): Metadata.LocalStorageKeys =>
  getAppMetadata().local_storage_keys
